module.exports = __webpack_public_path__ + "static/bizum-logo-small-ee7b124218e0b0b811fa4c6ffabb4700.svg";